"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementHours = void 0;
function incrementHours(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, hasReturnVal = utils.hasReturnVal, use = utils.use, a11yHasExpectedHtml = utils.a11yHasExpectedHtml;
    describe('Hours - Increment', function () {
        it('Should increment hours as expected on up key press', function () {
            loadPrimaryInput({ segment: 'hrs12' }).then(function () {
                use.upArrow().should('have.value', '09:30 PM').then(a11yHasExpectedHtml('<p>9.</p>')).then(hasReturnVal('21:30'));
                use.upArrow().should('have.value', '10:30 PM').then(a11yHasExpectedHtml('<p>10.</p>')).then(hasReturnVal('22:30'));
                use.upArrow().should('have.value', '11:30 PM').then(a11yHasExpectedHtml('<p>11.</p>')).then(hasReturnVal('23:30'));
                use.upArrow().should('have.value', '12:30 PM').then(a11yHasExpectedHtml('<p>12.</p>')).then(hasReturnVal('12:30'));
                var i = 1;
                while (i < 10) {
                    use.upArrow().should('have.value', "0".concat(i, ":30 PM")).then(a11yHasExpectedHtml("<p>".concat(i, ".</p>"))).then(hasReturnVal("".concat(i + 12, ":30")));
                    i++;
                }
            });
        });
    });
}
exports.incrementHours = incrementHours;
